import React from 'react';
import styled from 'styled-components';

import useDispensary from 'src/dispensary/hooks/use-dispensary';

import { Button, TextButton } from 'src/components/core';
import { Typography } from 'src/typography';
import { Statuses } from 'src/components/loyalty/use-loyalty';
import { getTermsOfUse } from 'src/components/loyalty/loyalty.helpers';

type TermsProps = {
  setStatus: (status: Statuses) => void;
  createUserAndPin: () => void;
  programName: string;
};

export const Terms = ({ setStatus, createUserAndPin, programName }: TermsProps): JSX.Element => {
  const { dispensary } = useDispensary();

  const handleCancel = (): void => {
    setStatus(Statuses.signup);
  };

  return (
    <Container data-testid='loyalty-terms'>
      <Heading tag='h2' size='small'>
        Terms of Use
      </Heading>

      <p>{getTermsOfUse(dispensary.name, programName, dispensary.location?.state)}</p>

      <ButtonContainer>
        <Button onClick={createUserAndPin} data-testid='agree'>
          Agree & Continue
        </Button>
        <StyledTextButton onClick={handleCancel}>Cancel</StyledTextButton>
      </ButtonContainer>
    </Container>
  );
};

const Container = styled.div`
  background: ${({ theme }) => theme.colors.primaryGrey};
  border: 1px solid ${({ theme }) => theme.colors.blueGrey[80]};
  border-radius: 6px;
  color: #646d72;
  padding: 24px 40px;
  text-align: center;
`;

const Heading = styled(Typography.Heading)`
  color: #121516;
  margin-bottom: 24px;
`;

const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
`;

const StyledTextButton = styled(TextButton)`
  font-weight: 600;
`;
